/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

// Sterowanie tabelą wyników; konfiguracja PL/EN jest w HTML.
(function(){
  var root=document.querySelector('[data-wyniki]'); if(!root) return;
  // Napisy skryptu ze slownika i18n — bez tego tabela mowila po
  // polsku takze na /en/results/* (daro, 19.09.2026).
  var configNode=document.getElementById("wyniki-konfig");
  if(!configNode) return;
  var config=JSON.parse(configNode.textContent), T=config.T;
  var tb=root.querySelector('[data-wyniki-tabela] tbody'); if(!tb) return;
  var rows=Array.prototype.slice.call(tb.rows);
  // The analysis sample is independent of the visible table page. SSR carries
  // the latest 25 draws; larger samples are fetched only after user choice.
  var malyEkran=window.matchMedia('(max-width:639px)');
  function limitStrony(){
    var select=root.querySelector("[data-wyniki-ile]");
    return Math.min(50,parseInt(select && select.value,10)||25);
  }
  tb.replaceChildren.apply(tb,rows.slice(0,limitStrony()));
  document.documentElement.classList.remove('wyniki-js-pending');
  window.clearTimeout(window.pewniakiWynikiStartTimer);
  var started=false;
  function start(){
  if(started) return; started=true;
  var selIle=root.querySelector('[data-wyniki-ile]');
  var inp=root.querySelector('[data-wyniki-szukaj]');
  var info=root.querySelector('[data-wyniki-info]');
  var strony=root.querySelector('[data-wyniki-strony]');
  var wszystkie=selIle.value==='all', ile=parseInt(selIle.value,10)||25, str=1, inicjalizacja=true;

  // DOCZYTYWANIE STARSZYCH LOSOWAN (13.09.2026, zgloszenie daro:
  // "500 nie dziala, nawet 200 - tabelka sie nie powieksza").
  // Serwer renderuje TYLKO 25 wierszy startowych (recent.json zawiera więcej,
  // w generatorze build-json; pelnej nazwy tego pliku PHP NIE pisz
  // tu nigdzie, nawet w komentarzu - bramka renderu w zdalne-wgraj.sh
  // bierze ten napis w HTML za komunikat pustego stanu i 14.09.2026
  // dwa razy odrzucila wysylke: 4 adresy wynikow "bez danych" przy
  // pelnej tabeli). Już 50 wierszy Multi Multi to około 289 kB HTML-u,
  // a 500 byłoby około 2,9 MB na każde wejście.
  // Przyciski 100/250/500 przelaczaly wiec tylko stronicowanie
  // po tych samych 50 wierszach. Teraz przy zakresie wiekszym
  // niz to, co jest w tabeli, skrypt sciaga roczniki
  // assets/json/db/{gra}/rok-RRRR.json (te same pliki, z ktorych
  // korzysta archiwum) idac wstecz od najstarszego wiersza, i
  // dokleja wiersze w TYM SAMYM ukladzie co Twig wyzej. Lotto:
  // 500 losowan to ~3 pliki po ~45 kB; Multi Multi: jeden
  // (310 kB). Pierwsze 25 zostaje z serwera - dla robota i bez JS.
  var pula=config.pula, kodGry=config.gra;
  // SSR cells already follow number order; do not move thousands of cells on startup.
  var zwyklyUklad=Array.from({length:pula},function(_,i){return i+1;}).join(',');
  var zaladowaneLata={}, doczytuje=false, koniecHistorii=false;
  var znane={}; rows.forEach(function(r){ znane[r.cells[0].textContent.trim()]=1; });
  // MACIERZ POWTORZEN (Fala 10, 30.09.2026; spec 2022 „Powtorzenia liczb”).
  // Kazdy wiersz pamieta komorki w kolejnosci liczb 1..pula (r._kom), zanim
  // ktokolwiek je przestawi. Pusta komorka dostaje data-n, bo licznik CSS
  // numeruje POZYCJE, a po ulozeniu kolumn wg trafien pozycja != liczba.
  function pamietaj(r){
    if(r._kom) return r;
    r._kom=Array.prototype.slice.call(r.cells,2,2+pula);
    r._primary=r._kom.map(function(c){
      var d=c.firstChild;
      return !!(d&&d.classList&&d.classList.contains('mapa-powt__trafienie')&&!d.classList.contains('mapa-powt__trafienie--plus'));
    });
    try { r._overlay=JSON.parse(r.getAttribute('data-lotto-overlay-numbers')||'[]'); } catch(e) { r._overlay=[]; }
    r._kom.forEach(function(c,i){ if(!c.firstChild) c.setAttribute('data-n',String(i+1)); });
    r._uklad=zwyklyUklad;
    return r;
  }
  rows.forEach(pamietaj);
  var tabela=root.querySelector('[data-wyniki-tabela]');
  var glowa=tabela.querySelector('[data-wyniki-naglowek]'); glowa._kom=Array.prototype.slice.call(glowa.cells,2,2+pula); glowa._uklad=zwyklyUklad;
  var stopa=tabela.querySelector('[data-wyniki-sumy]');
  if(stopa){ stopa._kom=Array.prototype.slice.call(stopa.cells,2,2+pula); stopa._uklad=zwyklyUklad; }
  var sumyN=root.querySelector('[data-wyniki-sumy-n]');
  var opisPowt=root.querySelector('[data-wyniki-powt]');
  var przyciskUklad=root.querySelector('[data-wyniki-uklad]');
  var poleOd=root.querySelector('[data-wyniki-od]');
  var przyciskWarstwy=root.querySelector('[data-lotto-overlay-toggle]'), warstwaWidoczna=false;
  var uklad='liczby', kotwicaNr=null;
  function nrWiersza(r){ return (r.cells[0].textContent||'').trim(); }
  function trafiona(c){ var d=c.firstChild; return !!(d&&d.classList&&d.classList.contains('mapa-powt__trafienie')&&!d.classList.contains('mapa-powt__trafienie--plus')); }
  function odswiezWarstweWiersza(r){
    if(kodGry!=='lotto'&&kodGry!=='lotto-plus') return;
    pamietaj(r);
    r._kom.forEach(function(c,i){
      var numer=i+1, glowna=!!r._primary[i], druga=warstwaWidoczna&&r._overlay.indexOf(numer)>=0;
      c.replaceChildren();
      if(glowna||druga){
        var d=document.createElement('div');
        d.className='mapa-powt__trafienie'+(glowna&&druga?' mapa-powt__trafienie--obie':(druga?' mapa-powt__trafienie--plus':''));
        d.textContent=String(numer); c.appendChild(d); c.removeAttribute('data-n');
      } else c.setAttribute('data-n',String(numer));
    });
  }
  function ustawWarstwe(stan){
    warstwaWidoczna=!!stan;
    rows.forEach(odswiezWarstweWiersza);
    if(przyciskWarstwy){
      przyciskWarstwy.setAttribute('aria-pressed',String(warstwaWidoczna));
      var napis=przyciskWarstwy.querySelector('span');
      if(napis) napis.textContent=warstwaWidoczna?przyciskWarstwy.dataset.hideLabel:przyciskWarstwy.dataset.showLabel;
    }
  }
  function uloz(r,kol,klucz){
    if(r._uklad===klucz) return;
    for(var i=0;i<kol.length;i++) r.appendChild(r._kom[kol[i]-1]);
    r._uklad=klucz;
  }
  var sep=jst("pages_wyniki_tabela_js.e08976b59225");
  function liczb(v){ var t=(Math.round(v*100)/100).toFixed(2).replace(/0+$/,'').replace(/\.$/,''); return t.replace('.',sep); }
  function macierz(zakres, widoczne){
    var ile_=[], pierwsze=[], n, i, j, lGl=0;
    for(n=1;n<=pula;n++){ ile_[n]=0; pierwsze[n]=Infinity; }
    for(i=0;i<zakres.length;i++){
      var r=pamietaj(zakres[i]), k=r._kom;
      for(j=0;j<pula;j++){
        if(trafiona(k[j])){ ile_[j+1]++; lGl++; if(pierwsze[j+1]===Infinity) pierwsze[j+1]=i; }
      }
    }
    var kol=[]; for(n=1;n<=pula;n++) kol.push(n);
    if(uklad==='powtorzenia'){
      kol.sort(function(a,b){ return (ile_[b]-ile_[a])||(pierwsze[a]-pierwsze[b])||(a-b); });
    }
    var klucz=kol.join(',');
    widoczne.forEach(function(r){ uloz(r,kol,klucz); });
    uloz(glowa,kol,klucz);
    if(stopa){
      uloz(stopa,kol,klucz);
      for(j=0;j<pula;j++){
        var licznik=stopa._kom[j].querySelector('[data-wyniki-licznik]');
        var glowna=licznik.querySelector('[data-wyniki-licznik-main]');
        if(glowna) glowna.textContent=String(ile_[j+1]); else licznik.textContent=String(ile_[j+1]);
        licznik.classList.toggle('wyniki-tabela__licznik--pionowy',wszystkie&&ile_[j+1]>=100);
        var etykieta=T.licznikGlowny.replace('%1',j+1).replace('%2',ile_[j+1]).replace('%3',zakres.length);
        stopa._kom[j].setAttribute('aria-label',etykieta);
      }
    }
    tabela.classList.toggle('mapa-powt--wg-trafien',uklad==='powtorzenia');
    if(sumyN) sumyN.textContent=T.sumaN.replace('%1',zakres.length);
    var en=config.en, de=config.de;
    var ranking=kol.slice().sort(function(a,b){ return (ile_[b]-ile_[a])||(pierwsze[a]-pierwsze[b])||(a-b); });
    var top=ranking.slice(0,kodGry==='multi-multi'?10:(kodGry==='mini-lotto'||kodGry==='eurojackpot'?5:(kodGry==='kaskada'?12:6)));
    var czestosc=root.querySelector('[data-wyniki-czestosc]'); czestosc.hidden=!zakres.length;
    root.querySelector('[data-wyniki-czestosc-n]').textContent='N = '+zakres.length;
    var opis=root.querySelector('[data-wyniki-czestosc-opis]');
    opis.textContent=T.opis;
    if(kodGry==='eurojackpot')opis.textContent+=(T.marketUi?(' '+T.marketUi.euro_separate):(de?jst("ui.8ebfe1ca379a5317"):(jst("pages_wyniki_tabela_js.9fa45ccd042e"))));
    if(!wszystkie&&zakres.length<ile)opis.textContent+=(T.marketUi?(' '+T.marketUi.frequency_requested+' '+ile+'; '+T.marketUi.frequency_available+' '+zakres.length+'. '+T.marketUi.frequency_only_available):(de?jst("fragment.23609559834d6999"): (jst("pages_wyniki_tabela_js.bedda7c94363")))+ile+(de?jst("ui.bb3b9019a54233eb"): (jst("pages_wyniki_tabela_js.1b82cece0d88")))+zakres.length+(de?'. Es werden nur verfügbare Ziehungen gezählt.': (jst("pages_wyniki_tabela_js.323dd41c2a95"))));
    var summary=root.querySelector('[data-wyniki-czestosc-liczby]'); summary.replaceChildren();
    top.forEach(function(n){
      var item=document.createElement('div'),ball=document.createElement('span'),count=document.createElement('span');
      item.className='wyniki-czestosc__liczba';ball.className='kula kula--'+kodGry;ball.textContent=n;
      ball.setAttribute('aria-label',jst('result.number_prefix')+n);count.textContent=ile_[n]+' / '+zakres.length;
      item.append(ball,count);summary.appendChild(item);
    });
    if(opisPowt){
      if(!zakres.length){ opisPowt.hidden=true; }
      else {
      var e=lGl/pula;   // srednio na liczbe: suma trafien glownych / pula
      opisPowt.textContent=T.powt.replace('%1',zakres.length)
        .replace('%2',nrWiersza(zakres[zakres.length-1])).replace('%3',nrWiersza(zakres[0]))
        .replace('%4',liczb(e))+(uklad==='powtorzenia'?' '+T.powtUklad:'');
      opisPowt.hidden=false;
      }
    }
    var draws=zakres.map(function(r){var ns=[];r._kom.forEach(function(c,i){if(r._primary[i])ns.push(i+1);});var time=r.querySelector('time');return {numbers:ns,special:JSON.parse(r.getAttribute('data-special')||'[]'),draw_system_id:nrWiersza(r),draw_number_estimated:r.hasAttribute('data-draw-number-estimated'),drawn_at:time?time.getAttribute('datetime'):''};});
    window.PewniakiWynikiZakres={game:kodGry,draws:draws,requested:wszystkie?'all':ile,counts:ile_.slice(1),top:top,missing:!!kotwicaNr&&!draws.some(function(d){return d.draw_system_id===kotwicaNr;})};
    root.dispatchEvent(new CustomEvent('pewniaki:wyniki-zakres',{bubbles:true,detail:window.PewniakiWynikiZakres}));
  }
  var wzorAdresu=(function(){ var a=tb.querySelector('a[href]'); return a?a.getAttribute('href'):null; })();
  function dwie(x){ return (x<10?'0':'')+x; }
  function potwierdzonyNumer(d){
    var fields=['legacy_id','draw_system_id'];
    for(var i=0;i<fields.length;i++){
      var value=d&&d[fields[i]];
      if((typeof value==='number'||typeof value==='string')&&/^[1-9][0-9]{0,11}$/.test(String(value))) return Number(value);
    }
    return null;
  }
  function numerLosowania(draws,index){
    var surowy=potwierdzonyNumer(draws[index]);
    if(surowy!==null) return String(surowy);
    for(var p=index-1;p>=0;p--){
      var nowszy=potwierdzonyNumer(draws[p]);
      if(nowszy!==null){var nr=nowszy-(index-p);return nr>0&&nr<=999999999999?String(nr):'';}
    }
    for(var n=index+1;n<draws.length;n++){
      var starszy=potwierdzonyNumer(draws[n]);
      if(starszy!==null){var nr=starszy+(n-index);return nr>0&&nr<=999999999999?String(nr):'';}
    }
    return '';
  }
  function wierszZ(d,nr,plusNumbers){
    nr=String(nr||d.legacy_id||d.draw_system_id||'');
    var iso=String(d.drawn_at||''), ymd=iso.slice(0,10), hm=iso.slice(11,16);
    var p=ymd.split('-'), dk=p[2]+'.'+p[1]+'.'+p[0];
    var wyn=d.numbers||[], spec=d.special||[], plus=plusNumbers||[];
    var tr=document.createElement('tr');
    tr.setAttribute('data-szukaj',dk+' '+nr);
    if(nr&&potwierdzonyNumer(d)===null) tr.setAttribute('data-draw-number-estimated','1');
    tr.setAttribute('data-special',JSON.stringify(spec));
    if(kodGry==='lotto'||kodGry==='lotto-plus') tr.setAttribute('data-lotto-overlay-numbers',JSON.stringify(plus));
    var h='<th scope="row" class="tabular-nums">'+nr+'</th><td class="mapa-powt__data">';
    var czas=jst("fragment.f67c57ed8cf8fd1f")+iso+'">'+dk+(hm?' '+hm:'')+'</time>';
    var adres=null;
    if(wzorAdresu){
      var url=new URL(wzorAdresu,location.href);
      url.pathname=url.pathname.replace(/\d{4}-\d{2}-\d{2}(?=\/?$)/,ymd);
      url.hash=nr?'losowanie-'+nr:'';
      adres=url.pathname+url.search+url.hash;
    }
    h+=adres?jst("fragment.02c400f14d7569ed")+adres+'" class="text-primary hover:text-primaryDark hover:underline">'+czas+'</a>':czas;
    h+='</td>';
    for(var n=1;n<=pula;n++){
      var co10=(n%10===0)?'mapa-powt__co10':'';
      var w=wyn.indexOf(n)>=0, s=spec.indexOf(n)>=0;
      if(w||s){
        var kl='mapa-powt__trafienie'+(w&&s?' mapa-powt__trafienie--obie':(s?' mapa-powt__trafienie--plus':''));
        h+='<td'+(co10?' class="'+co10+'"':'')+'><div class="'+kl+'">'+n+'</div></td>';
      } else {
        h+=jst("fragment.58d8ba117ce97804")+n+'"'+(co10?' class="'+co10+'"':'')+'></td>';
      }
    }
    tr.innerHTML=h;
    pamietaj(tr); odswiezWarstweWiersza(tr); return tr;
  }
  function najstarszyRok(){
    var min=null;
    rows.forEach(function(r){ var t=r.querySelector('time'); var v=t?t.getAttribute('datetime'):''; if(v&&(min===null||v<min)) min=v; });
    return min?parseInt(min.slice(0,4),10):(new Date()).getFullYear();
  }
  function doladuj(n, warunek){
    if(doczytuje||koniecHistorii||(!warunek&&n<=rows.length)||(warunek&&warunek())) return;
    doczytuje=true;
    var rok=najstarszyRok(), plikow=0, nowe=0;
    info.textContent=T.doczytuje;
    function dalej(){
      if(!warunek)n=ile;
      if(warunek?warunek():rows.length>=n){ zakoncz(); return; }
      if(rok<1957){ koniecHistorii=true; zakoncz(); return; }
      if(plikow>=(warunek?80:15)){ zakoncz(); return; }
      if(zaladowaneLata[rok]){ rok--; dalej(); return; }
      zaladowaneLata[rok]=1; plikow++;
      var adres='/assets/json/db/'+kodGry+'/rok-'+rok+'.json';
      var graWarstwy=kodGry==='lotto'?'lotto-plus':(kodGry==='lotto-plus'?'lotto':'');
      var pobierzPlus=graWarstwy
        ? fetch('/assets/json/db/'+graWarstwy+'/rok-'+rok+'.json',{cache:'force-cache'}).then(function(r){return r.ok?r.json():{draws:[]};}).catch(function(){return {draws:[]};})
        : Promise.resolve({draws:[]});
      Promise.all([fetch(adres,{cache:'force-cache'}).then(function(r){ if(!r.ok) throw new Error('brak '+rok); return r.json(); }),pobierzPlus])
        .then(function(pliki){
          var j=pliki[0], plikPlus=pliki[1], rocznik=j.draws||[], plusByDraw={};
          (plikPlus.draws||[]).forEach(function(d){var id=String(d.legacy_id||d.draw_system_id||'');if(id)plusByDraw[id]=d.numbers||[];});
          rocznik.forEach(function(d,index){
            var nr=numerLosowania(rocznik,index);
            if(!nr||znane[nr]) return;
            znane[nr]=1; var tr=wierszZ(d,nr,plusByDraw[nr]||[]); rows.push(tr); nowe++;
          });
          rok--; dalej();
        })
        .catch(function(){ koniecHistorii=true; zakoncz(); });
    }
    function zakoncz(){
      doczytuje=false;
      if(wszystkie) ile=rows.length;
      if(sortKol) zastosujSort();   // ta sama kolumna i kierunek co przed doczytaniem
      render();
      if(koniecHistorii&&rows.length<n){ info.textContent+=' '+T.historia.replace('%1',rows.length); }
      if(wszystkie&&!koniecHistorii) doladuj(Number.MAX_SAFE_INTEGER,function(){return false;});
    }
    dalej();
  }

  if(przyciskWarstwy) przyciskWarstwy.onclick=function(){ ustawWarstwe(!warstwaWidoczna); render(); };

  function filtr(){
    var q=(inp.value||'').trim().toLowerCase();
    if(!q) return rows;
    return rows.filter(function(r){return (r.getAttribute('data-szukaj')||'').toLowerCase().indexOf(q)>=0;});
  }
  function render(){
    if(inicjalizacja) return;
    var f=filtr().slice().sort(function(a,b){var x=a.querySelector('time'),y=b.querySelector('time');return String(y?y.getAttribute('datetime'):'').localeCompare(String(x?x.getAttribute('datetime'):''))||Number(nrWiersza(b))-Number(nrWiersza(a));}), n=f.length, baza=0, brakKotwicy=false;
    // Kotwica „od losowania nr” dziala na liscie bez szukajki: okno zaczyna sie
    // od wskazanego wiersza w biezacej kolejnosci (domyslnie od najnowszego).
    if(kotwicaNr&&!(inp.value||'').trim()){
      baza=-1;
      for(var q=0;q<f.length;q++){ if(nrWiersza(f[q])===kotwicaNr){ baza=q; break; } }
      if(baza<0){ baza=0; brakKotwicy=true; }
    }
    var zakres=brakKotwicy?[]:f.slice(baza,wszystkie?f.length:baza+ile), wybrane=new Set(zakres), widok=rows.filter(function(r){return wybrane.has(r);});
    var pelny=root.classList.contains('sw-pelny');
    var naStronie=pelny?Math.max(1,zakres.length):Math.min(50,zakres.length||ile), stron=Math.max(1,Math.ceil(zakres.length/naStronie));
    // Pełny ekran obejmuje całą wybraną próbę. Numer zwykłej strony zostaje
    // zachowany, żeby po zamknięciu wrócić do poprzedniego miejsca.
    if(!pelny){ if(str>stron) str=stron; if(str<1) str=1; }
    var od=pelny?0:(str-1)*naStronie, doo=Math.min(od+naStronie,zakres.length), i, widoczne=[];
    for(i=od;i<doo;i++){ widoczne.push(widok[i]); }
    // Zwykły widok montuje jedną stronę; pełny ekran wszystkie wybrane wiersze.
    tb.replaceChildren.apply(tb,widoczne);
    info.textContent = zakres.length ? T.wiersz.replace('%1',od+1).replace('%2',doo).replace('%3',zakres.length) : T.brak;
    if(brakKotwicy) info.textContent+=' '+(doczytuje?T.odSzukam:T.odBrak).replace('%1',kotwicaNr);
    macierz(zakres,widoczne);
    strony.innerHTML='';
    if(stron>1){
      var numery=[];
      if(stron<=12){ for(var p=1;p<=stron;p++) numery.push(p); }
      else {
        numery.push(1);
        for(var p=Math.max(2,str-2);p<=Math.min(stron-1,str+2);p++) numery.push(p);
        numery.push(stron);
      }
      var poprzednia=0;
      numery.filter(function(p,i,a){return a.indexOf(p)===i;}).forEach(function(p){
        if(poprzednia&&p>poprzednia+1){var luka=document.createElement('span');luka.textContent='…';luka.setAttribute('aria-hidden','true');strony.appendChild(luka);}
        (function(p){
        var b=document.createElement('button');
        var akt=(p===str);
        b.type='button'; b.textContent=p;
        b.className='wyniki-strona'+(akt?' wyniki-strona--akt':'');
        b.setAttribute('aria-label',T.strona.replace('%1',p));
        // Biezaca strona: aria-current mowi czytnikowi ekranu
        // "strona 3, biezaca", a disabled zdejmuje ja z kolejki
        // Taba - klikniecie w strone, na ktorej juz jestes,
        // i tak nic nie robi. (11.09.2026)
        if(akt){ b.setAttribute('aria-current','page'); b.disabled=true; }
        else { b.onclick=function(){str=p;render();}; }
        strony.appendChild(b);
        })(p);
        poprzednia=p;
      });
    }
    // Siatka-widok przelicza skale i kopie z zamienionymi osiami.
    root.dispatchEvent(new Event('sw:odswiez'));
  }
  root.addEventListener('change',function(e){
    if(e.target.matches('[data-wyniki-ile]')) ustawZakres(e.target.value,true);
  });
  root.addEventListener('sw:pelny',render);
  inp.oninput=function(){str=1;render();};
  if(malyEkran.addEventListener)malyEkran.addEventListener('change',function(){str=1;render();});

  // Zakresy 7/14/25/... i pole na własną liczbę. Obie drogi
  // prowadzą do TEJ SAMEJ zmiennej `ile` — <select> nad nagłówkiem
  // zostaje jako jedno źródło stanu, żeby nie trzymać liczby
  // w dwóch miejscach i nie rozjechać ich przy sortowaniu.
  var przyciski=root.querySelectorAll('[data-wyniki-zakres]');
  var wlasny=root.querySelector('[data-wyniki-wlasny]');
  var analitykaZakresGotowa=false;
  function zglosZakres(n, zPrzycisku){
    if(!analitykaZakresGotowa||!zPrzycisku||!root.PewniakiZestawy)return;
    var dozwolone=['7','14','25','50','100','250','500','all'], wartosc=String(n);
    var sklep=root.PewniakiZestawy.sklep();
    sklep.zdarzenie('result_range_change',kodGry,'wyniki',sklep.lista(kodGry).length,{range:dozwolone.indexOf(wartosc)>=0?wartosc:'custom'});
  }
  function ustawZakres(n, zPrzycisku){
    if(String(n)==='all'){
      wszystkie=true; ile=rows.length; str=1;
      inp.value=''; kotwicaNr=null;
      if(poleOd) poleOd.value='';
      selIle.value='all';
      document.querySelectorAll('[data-wyniki-zakres-sync]').forEach(function(s){s.value='all';});
      przyciski.forEach(function(b){
        var akt=b.getAttribute('data-wyniki-zakres')==='all';
        b.hidden=akt;
        b.classList.toggle('wyniki-zakres--akt',akt);
        if(akt) b.setAttribute('aria-current','true'); else b.removeAttribute('aria-current');
      });
      if(zPrzycisku&&wlasny) wlasny.value='';
      render();
      zglosZakres('all',zPrzycisku);
      doladuj(Number.MAX_SAFE_INTEGER,function(){return false;});
      return;
    }
    n=parseInt(n,10);
    if(!n||n<1||n>5000) return;
    wszystkie=false; ile=n; str=1;
    var wlasnaOpcja=selIle.querySelector('[data-wyniki-wlasna-opcja]');
    if(wlasnaOpcja) wlasnaOpcja.remove();
    if(!Array.prototype.some.call(selIle.options,function(o){return Number(o.value)===n;})){
      var opcja=document.createElement('option');opcja.value=String(n);opcja.textContent=String(n);opcja.setAttribute('data-wyniki-wlasna-opcja','');selIle.appendChild(opcja);
    }
    selIle.value=String(n);
    document.querySelectorAll('[data-wyniki-zakres-sync]').forEach(function(s){
      if(!Array.from(s.options).some(function(o){return Number(o.value)===n;})){var o=document.createElement('option');o.value=String(n);o.textContent=String(n);s.appendChild(o);}
      s.value=String(n);
    });
    przyciski.forEach(function(b){
      var akt=parseInt(b.getAttribute('data-wyniki-zakres'),10)===n;
      b.hidden=akt;
      b.classList.toggle('wyniki-zakres--akt',akt);
      if(akt) b.setAttribute('aria-current','true');
      else b.removeAttribute('aria-current');
    });
    if(zPrzycisku&&wlasny) wlasny.value='';
    render();
    zglosZakres(n,zPrzycisku);
    // Zakres wiekszy niz to, co jest w tabeli - dociagamy roczniki
    // (patrz doladuj wyzej). Przy wpisywaniu z klawiatury czekamy
    // 400 ms, zeby "5", "50", "500" nie odpalily trzech pobran.
    if(n>rows.length){
      clearTimeout(ustawZakres.t);
      ustawZakres.t=setTimeout(function(){ doladuj(ile); }, zPrzycisku?0:400);
    }
  }
  przyciski.forEach(function(b){
    b.onclick=function(){ustawZakres(b.getAttribute('data-wyniki-zakres'),true);};
  });
  if(wlasny){
    // `input`, nie `change` — liczba ma działać w trakcie pisania,
    // bez wciskania Entera. Pusta wartość nie zeruje widoku.
    wlasny.oninput=function(){ if(wlasny.value!=='') ustawZakres(wlasny.value,false); };
  }
  document.querySelectorAll('[data-wyniki-zakres-sync]:not([data-wyniki-ile])').forEach(function(s){s.addEventListener('change',function(){ustawZakres(s.value,true);});});
  ustawZakres(selIle.value,true);
  analitykaZakresGotowa=true;

  // Sortowanie kolumn "losowanie" (numer) i "data" — jak na produkcji.
  var sortKol=null, sortDir=1;
  function wartosc(r,kol){
    if(kol==='nr'){ return parseInt((r.cells[0].textContent||'').replace(/\D/g,''),10)||0; }
    var t=r.querySelector('time'); return t?(t.getAttribute('datetime')||t.textContent):'';
  }
  function oznacz(){
    root.querySelectorAll('[data-sort]').forEach(function(th){
      var k=th.getAttribute('data-sort'), s=th.querySelector('.mapa-powt__strzalka');
      if(k===sortKol){ th.setAttribute('aria-sort',sortDir>0?'ascending':'descending'); if(s) s.textContent=sortDir>0?'▲':'▼'; }
      else { th.setAttribute('aria-sort','none'); if(s) s.textContent='⇅'; }
    });
  }
  // Samo przestawienie wierszy wg biezacej kolumny i kierunku -
  // wolane tez po doczytaniu rocznikow, zeby nowe wiersze weszly
  // w porzadek zamiast doklejac sie na koncu.
  function zastosujSort(){
    var kol=sortKol;
    rows.sort(function(a,b){ var va=wartosc(a,kol), vb=wartosc(b,kol); return va<vb?-sortDir:(va>vb?sortDir:0); });
  }
  function sortuj(kol){
    if(sortKol===kol){ sortDir=-sortDir; } else { sortKol=kol; sortDir=1; }
    zastosujSort();
    str=1; render(); oznacz();
  }
  root.querySelectorAll('[data-sort]').forEach(function(th){
    th.addEventListener('click',function(){ sortuj(th.getAttribute('data-sort')); });
  });

  // Sortowanie i liczniki używają całego wybranego okna, nie strony tabeli.
  function ustawUklad(wg){
    uklad=wg?'powtorzenia':'liczby';
    if(przyciskUklad) przyciskUklad.setAttribute('aria-pressed',wg?'true':'false');
    render();
  }
  if(przyciskUklad) przyciskUklad.onclick=function(){ ustawUklad(uklad!=='powtorzenia'); };
  // Poczatek okna: numer losowania. Pusta wartosc wraca do najnowszego.
  function ustawKotwice(v){
    v=String(v||'').replace(/\D/g,'');
    kotwicaNr=v?String(parseInt(v,10)):null; str=1;
    render();
    if(!kotwicaNr) return;
    var cel=parseInt(kotwicaNr,10);
    // Stop: numer znaleziony i za nim jest cale okno ALBO wczytane juz sa starsze
    // losowania niz szukane (takiego numeru nie ma — bez sciagania calej historii).
    var jest=function(){
      var min=Infinity, idx=-1;
      for(var q=0;q<rows.length;q++){ var v=parseInt(nrWiersza(rows[q]),10); if(v<min) min=v; if(String(v)===kotwicaNr) idx=q; }
      return idx>=0 ? rows.length>=idx+ile : min<cel;
    };
    if(!jest()) doladuj(0, jest);
  }
  if(poleOd){
    poleOd.oninput=function(){ clearTimeout(ustawKotwice.t); ustawKotwice.t=setTimeout(function(){ ustawKotwice(poleOd.value); },400); };
  }
  // Adres z innych stron: ?ile=7&od=13658&uklad=powtorzenia (bez zapisu stanu w adresie).
  try {
    var par=new URLSearchParams(window.location.search);
    if(par.get('ile')==='all') ustawZakres('all',false);
    // Public number links use okno; older grid links use ile.
    var pIle=parseInt(par.get('ile')||par.get('okno')||'',10);
    if(pIle>=1&&pIle<=5000){
      var zPrz=Array.prototype.some.call(przyciski,function(b){ return parseInt(b.getAttribute('data-wyniki-zakres'),10)===pIle; });
      if(!zPrz&&wlasny) wlasny.value=String(pIle);
      ustawZakres(pIle,zPrz);
    }
    if(par.get('uklad')==='powtorzenia'){ ustawUklad(true); }
    var pOd=(par.get('od')||'').replace(/\D/g,'');
    if(pOd&&poleOd){ poleOd.value=pOd; ustawKotwice(pOd); }
    var query=par.get('szukaj')||'';
    if(query.length<=60) inp.value=query;
    if(par.get('warstwa')==='1'&&przyciskWarstwy) ustawWarstwe(true);
    var savedSort=par.get('sort')||'';
    if(/^(?:nr|data)-(?:asc|desc)$/.test(savedSort)){
      var parts=savedSort.split('-');
      sortuj(parts[0]);
      if(parts[1]==='desc') sortuj(parts[0]);
    }
  } catch(e) { /* stara przegladarka bez URLSearchParams: zwykly widok */ }

  inicjalizacja=false;
  render(); oznacz();
  }
  // Obliczenia daleko pod pierwszym ekranem uruchamiamy przed wejściem w tabelę.
  root.addEventListener('focusin',start,{once:true});
  document.querySelectorAll('[data-wyniki-zakres-sync]').forEach(function(s){s.addEventListener('focus',start,{once:true});s.addEventListener('pointerdown',start,{once:true});});
  document.addEventListener('change',function(e){if(e.target.matches('[data-wyniki-zakres-sync]')){var value=e.target.value;start();e.target.value=value;}},true);
  root.addEventListener('pointerdown',start,{once:true});
  if(typeof window.IntersectionObserver === 'function'){
    var observer=new IntersectionObserver(function(entries){
      if(entries.some(function(e){return e.isIntersecting;})){observer.disconnect();start();}
    },{rootMargin:'400px'});
    observer.observe(root);
  }else start();
  // A number deep link needs its sample before the detail panel is opened.
  // Normal visits retain the lazy table initialization.
  var initialNumber=new URLSearchParams(window.location.search).get('liczba');
  if(/^[1-9][0-9]*$/.test(initialNumber||'')&&Number(initialNumber)<=config.pula) start();
})();

